import React, { useState } from 'react';
import SearchBar from './components/Weather/SearchBar';
import WeatherCard from './components/Weather/WeatherCard';
import { fetchWeather } from './services/weatherService';
import GlassPanel from './components/common/GlassPanel';

function App() {
  const [weatherData, setWeatherData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = async (city) => {
    if (!city) return;

    setLoading(true);
    setError(null);

    try {
      const data = await fetchWeather(city);
      setWeatherData(data);
    } catch (err) {
      setError(err.message || 'No se pudo encontrar la ciudad');
      setWeatherData(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <header style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <h3 style={{
          fontSize: '0.9rem',
          textTransform: 'uppercase',
          letterSpacing: '2px',
          color: 'var(--accent-cyan)',
          fontWeight: '600'
        }}>
          Weather App
        </h3>
      </header>

      <SearchBar onSearch={handleSearch} />

      {loading && (
        <GlassPanel style={{ textAlign: 'center' }}>
          <p>Buscando clima...</p>
        </GlassPanel>
      )}

      {error && (
        <GlassPanel style={{ border: '1px solid hsla(0, 100%, 50%, 0.3)' }}>
          <p style={{ color: '#ff4d4d', textAlign: 'center' }}>{error}</p>
        </GlassPanel>
      )}

      {!weatherData && !loading && !error && (
        <GlassPanel className="animate-fade">
          <p style={{ textAlign: 'center', color: 'var(--text-muted)' }}>
            Ingresa una ciudad para ver el clima actual.
          </p>
        </GlassPanel>
      )}

      {weatherData && !loading && (
        <WeatherCard data={weatherData} />
      )}

      <footer style={{
        textAlign: 'center',
        marginTop: '2rem',
        color: 'var(--text-muted)',
        fontSize: '0.8rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem'
      }}>
        <span>Powered by OpenWeatherMap</span>
        <span>
          Created by{' '}
          <a 
            href="https://github.com/devkopi" 
            target="_blank" 
            rel="noopener noreferrer"
            className="author-link"
          >
            devkopi
          </a>
        </span>
      </footer>
    </div>
  );
}

export default App;